import { CreateService } from '@/services/service';
import { GiftReactionEntity } from '@/entities/gift-reaction.entity';

export default class GiftReactionService extends CreateService<GiftReactionEntity>(
  'post-reaction',
) {
  async getMany(
    postId: string | number,
    emoticonId: string | number,
  ): Promise<GiftReactionEntity[]> {
    await this.apiBuilder.reset();
    const [items] = await this.apiBuilder
      .clone()
      .join('staff')
      .filter('postId', '$eq', String(postId))
      .filter('emoticonId', '$eq', String(emoticonId))
      .getMany();
    return items;
  }
}
